export default "__VITE_ASSET__CNzzp7oe__"